'use strict';
const Actions = require('../actions');
const Button = require('../../../../components/form/button.jsx');
const ControlGroup = require('../../../../components/form/control-group.jsx');
const React = require('react');
const ReactHelmet = require('react-helmet');
const ReactRouter = require('react-router-dom');
const Spinner = require('../../../../components/form/spinner.jsx');
const Store = require('./store');
const TextControl = require('../../../../components/form/text-control.jsx');

// import ToastrContainer from 'react-toastr-basic'
// import { ToastSuccess, ToastDanger } from 'react-toastr-basic'

const Helmet = ReactHelmet.Helmet;
const Link = ReactRouter.Link;


class ForgotPage extends React.Component {
    constructor(props) {

        super(props);

        this.input = {};
        this.state = Store.getState();
    }

    componentDidMount() {
        this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

        if (this.input.username) {
            this.input.username.focus();
        }
    }


    componentWillUnmount() {
        this.unsubscribeStore();
    }

    onStoreChange() {
        let newState = Store.getState();
        this.setState(newState);
    }

    handleSubmit(event) {

        event.preventDefault();
        event.stopPropagation();

        Actions.forgot({
            username: this.input.username.value,
            phone: this.input.phone.value
        }, (err) => {
            if (err) {
                window.notify('error', err.message);
            } else {
                window.notify('warning', `אם שם המשתמש ומספר הטלפון נכונים, תקבל SMS לאיפוס הסיסמה.`);
                setTimeout(() => {
                    Actions.clearSuccess();
                    // GO TO LOGIN.
                    this.props.history.push({
                        pathname: '/login',
                    });
                }, 5000);
            }

        });
    }

    render() {

        const alerts = [];
        let formElements;

        formElements = (<form onSubmit={ this.handleSubmit.bind(this) }>
            <div className="logo-wrapper">
                <img
                    className="login-logo"
                    src="/public/media/logo.png"
                />
            </div>
            <div className="form">
                <div className="control">
                    <label htmlFor="username" className="fa fa-user"/>
                    <input id="username"
                           disabled={ this.state.loading || this.state.success }
                           ref={ (c) => (this.input.username = c) }
                           placeholder="Username" type="text"/>
                </div>
                <div className="control">
                    <label htmlFor="phone" className="fa fa-phone"/>
                    <input id="phone"
                           disabled={ this.state.loading || this.state.success }
                           ref={ (c) => (this.input.phone = c) }
                           placeholder="Enter phone number (ex 052-4443333)" type="text"/>
                </div>
                <div className="control">
                    <Button
                        type="submit"
                        inputClasses={ { 'submit-login-button': true } }
                        disabled={ this.state.loading || this.state.success }>

                        Restore
                        <Spinner space="left" show={ this.state.loading }/>
                    </Button>
                </div>
            </div>
        </form>);

        return (
            <section className="container">
                <Helmet>
                    <title>Forgot password</title>
                </Helmet>
                <section className="container">
                    <Helmet>
                        <title>Sign in</title>
                    </Helmet>
                    <img src="/public/media/background-image.jpg" className="background-full-image"/>
                    <div className="container center-flex-container">
                        { formElements }
                    </div>
                    { alerts }
                    { /*<ToastrContainer />*/ }

                </section>
            </section>
        );
    }
}


module.exports = ForgotPage;



// WEBPACK FOOTER //
// ./client/pages/main/login/forgot/index.jsx